import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {WatchGroup} from '@acng/frontend-relativity';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {ctxPinsAvailable} from '../context/available.js';
import {toggle} from '../service/style.js';

/**
 * @group DOM Attribute
 */
const name = 'class-pin';

AttributeSetup(name, () => {
  const watch = WatchGroup(attributeSelector(name), ctxAmateur, ctxPinsAvailable);

  AttributeLink(name, (element) => watch(element, (element, [amateur]) => toggle(element, amateur)));
});

export {name as CLASS_PIN};
